import * as React from 'react'
import { Form, Input, Button, Select } from 'antd'
import { Encrypt, Decrypt } from '../../../../javascripts/aes'
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { LoginDevice } from '../../../../javascripts/public';

const FormItem = Form.Item;
interface PropsType {
    login: Function
    forget: Function
    loginFailData: string
}

class LoginForm extends React.Component<PropsType> {


    onFinish = (values) => {
        console.log('Received values of form: ', values);
        let password = Encrypt(values.password);
        localStorage.setItem('password', password);
        localStorage.setItem('username', values.username);
        localStorage.setItem('loginDevice', values.device);
        this.props.login(values, false);
    }

    onFinishFailed = (errorInfo) => {
        console.log('error', errorInfo)
    }

    render() {

        let username = localStorage.getItem('username') || '';
        let password = localStorage.getItem('password') || '';
        let loginDevice = localStorage.getItem('loginDevice') || LoginDevice.SCANNER;
        if (password) password = Decrypt(password);
        let loginFailData = this.props.loginFailData;

        return (
            <Form
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
                className="login-form"
                initialValues={{
                    device: loginDevice,
                    username: username,
                    password: password,
                }}>
                <FormItem
                    name='device'
                    rules={[{ required: true, message: '请选择设备', whitespace: true}]}>
                    <Select>
                        <Select.Option value={LoginDevice.SCANNER}>扫脚仪</Select.Option>
                        <Select.Option value={LoginDevice.SILIZHU}>四立柱</Select.Option>
                    </Select>
                </FormItem>
                <FormItem
                    name='username'
                    rules={[{ required: true, message: '请输入用户名', whitespace: true }]}>
                    <Input
                        size="large"
                        prefix={<UserOutlined />}
                        placeholder="请输入用户名"
                    />
                </FormItem>
                <FormItem
                    name='password'
                    rules={[{ required: true, message: '请输入密码', whitespace: true }]}>
                    <Input.Password
                        size="large"
                        prefix={<LockOutlined />}
                        type="password"
                        placeholder="请输入密码"
                        />
                </FormItem>
                <div className="overflow-hidden">
                    <a className="right" onClick={() => this.props.forget()}>忘记密码</a>
                </div>
                <FormItem>
                    <Button
                        type="primary"
                        size="large"
                        htmlType="submit"
                        className='btn_password_login'
                    >登录</Button>
                    {loginFailData && <p className="error">{loginFailData}</p>}
                </FormItem>
            </Form>
        );
    }
}

export default LoginForm